import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoTipoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findByTela(tela) {
        return this._http.get(`${this._env}/exporttypes/types/${tela}.json`, this._headers)
                .then(res => res.body, this.handleError);
    }
}